import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import classnames from "classnames";
import Helmet from "react-helmet";
import { injectIntl } from "gatsby-plugin-intl";
import Navigation from "../navigation/Navigation";
import Footer from "../footer/Footer";
import "../../styles/index.scss";
import cssClass from "./Layout.module.scss";

const Layout = ({ children, navInvert, underNav, seo = {} }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  const classes = classnames(cssClass.layout, {
    [cssClass.underNav]: underNav,
  });

  const metaTitle = `${seo.title ? `${seo.title} | ` : ""}${
    data.site.siteMetadata.title
  }`;

  // TODO: Default image needed

  return (
    <div className={classes}>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={seo.description || ""} />
        <meta name="image" content={seo.image || ""} />
        <meta property="og:url" content={seo.url || ""} />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={seo.description || ""} />
        <meta property="og:image" content={seo.image || ""} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={metaTitle} />
        <meta name="twitter:description" content={seo.description || ""} />
        <meta name="twitter:image" content={seo.image || ""} />
      </Helmet>
      <Navigation invert={navInvert} />
      {children}
      <Footer />
    </div>
  );
};

export default injectIntl(Layout);
